import Widget, { IWidgetConsumer } from 'app/components/common/Widget';
import { WidgetNavigate } from 'app/components/common/WidgetNavigate';
import { useStore } from 'app/context';
import { LeadNowConvVM } from 'app/stores/ui/agt.leadnow.conv.ui.store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { LeadNowConversionFunnelChart } from './LeadNowConversionFunnelChart';

// Dashboard widget showing the LeadNow conversion funnel aggregated across all of
// the VBL's agencies. The underlying store scopes agenturen to the logged-in user,
// so no manual filtering is needed. The KW range defaults to YTD (set in the
// store's _baseLoad), so the widget has no date picker. averageItems is omitted
// because the funnel already represents the aggregate of all agts.
export const LeadNowConversionWidget = observer((props: IWidgetConsumer) => {
	const { agtLeadNowConvUiStore } = useStore();
	const [funnelItems, setFunnelItems] = useState<LeadNowConvVM[]>([]);

	useEffect(() => {
		agtLeadNowConvUiStore.load().then(() => {
			if (agtLeadNowConvUiStore.minKw && agtLeadNowConvUiStore.maxKw) {
				agtLeadNowConvUiStore.aggregateAgtsByKw(agtLeadNowConvUiStore.minKw, agtLeadNowConvUiStore.maxKw).then(setFunnelItems);
			}
		});
	}, [agtLeadNowConvUiStore]);

	if (funnelItems.length === 0) {
		return <></>;
	}

	return (
		<Widget title={'AMIS.Now Leads Abschlußquote'} action={<WidgetNavigate text={'Zum Bericht'} path={'/berichte/kunde/leadnow/conv/liste'} />} widgetId={props.widgetKey}>
			<LeadNowConversionFunnelChart items={funnelItems} modifier="is-widget is-paddingless" height={125} />
		</Widget>
	);
});
